<template>
    <div class="add-portfolio container mt-5">
        <h1 class="text-center">
            Add Portfolio
        </h1>
        <add/>
    </div>
</template>

<script>
import add from '../components/Add.vue'
export default {
    name: "AddPortfolio",
    components: {
        add,
    }
}
</script>

<style>

</style>
